export const QUADRANT_SCATTER_CONFIG: Highcharts.Options = {
  chart: { type: "scatter" },
  title: { text: "", align: "left" },
  credits: { enabled: false },
  accessibility: { enabled: false },
  legend: {
    enabled: true,
    align: "center",
    verticalAlign: "bottom",
    layout: "horizontal",
    itemStyle: { fontSize: "12px", fontWeight: "normal", color: "#333" },
    symbolRadius: 6,
  },
  exporting: {
    enabled: true,
    fallbackToExportServer: true,
    sourceWidth: 1400,
    sourceHeight: 600,
    scale: 2,
    buttons: {
      contextButton: {
        align: "right",
        verticalAlign: "top",
        y: -43,
        x: -30,
      },
    },
  },
};
